<template>
	<div class="hero-v2" :style="`background-image: url('${ topSection.background_url }')`">
		<div class="container">
			<div class="row">
				<div class="col-xs-8 col-sm-8 col-md-7">
					<div class="hero-v2__content">
						<h4 class="hero-v2__subheading">
							{{ topSection.body | stripTags }}
						</h4>
						<h1 class="hero-v2__heading">
							{{ topSection.title | stripTags }}
						</h1>
						<ol class="hero-v2__step-list">
							<li class="hero-v2__step">
								<span>1</span> Choose your game
							</li>
							<li class="hero-v2__step">
								<span>2</span> Pick your price
							</li>
							<li class="hero-v2__step">
								<span>3</span> We’ll Build it!
							</li>
						</ol>
						<router-link
							:to="{ name: 'step1' }"
							class="hero-v2__cta btn hide-mobile"
						>
							Start Your PC
						</router-link>
					</div>
				</div>
				<div class="hero-v2__image-container">
					<div class="hero-v2__image">
						<img :src="topSection.logo_url" alt="BLD PC with nvidia 3000 series sticker">
					</div>
				</div>
			</div>
			<router-link
				:to="{ name: 'step1' }"
				class="hero-v2__cta btn"
			>
				Start Your PC
			</router-link>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "HeroDefaultV2",
	computed: {
		...mapState({
			topSection: state => state.Home.topSection
		})
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.hero-v2 {
    color: #FFF;
    font-family: "Akkurat-Pro";
    background-color: #0F0117;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 40px 0 30px;
    margin: 0 -15px;
    overflow-x: hidden;

    @media (min-width: 700px) {
        padding: 40px 0 75px;
    }

    .row {
        display: flex;

        > div {
            display: flex;
            flex-shrink: 0;
        }
    }

    &__content {
        font-size: 16px;
        letter-spacing: 0;
        margin: 0 0 10px;

        @media (min-width: 1200px) {
            margin-top: 90px;
        }

        @media (min-width: 600px) and (max-width: 1200px) {
            margin-top: 60px;
            padding-left: 50px;
        }
    }

    &__subheading {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 19px;
        margin: 0 0 10px;
        text-transform: uppercase;
    }

    &__heading {
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 38px;
        margin: 0 0 20px;

        @media (min-width: 700px) {
            font-size: 48px;
            line-height: 58px;
            max-width: initial;
        }
    }

    &__step-list {
        margin: 0;
        list-style: none;
        padding-left: 0;

        @media (min-width: 700px) {
            margin-bottom: 45px;
        }
    }

    &__step {
        margin-bottom: 15px;
        font-size: 16px;
        display: flex;
        align-items: center;

        span {
            height: 36px;
            width: 36px;
            color: #FFF;
            font-size: 20px;
            border-radius: 50%;
            margin-right: 15px;
            background-color: rgba(255, 255, 255, 0.14);
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__cta {
        padding: 12px 58px;
        display: block;
        background-color: $oldpurple;
        text-transform: none;
        color: #FFF;
        font-weight: bold;
        font-size: 16px;

        &:hover {
            background: #FFF;
            color: $orchid;
        }

        @media (min-width: 700px) {
            display: none;
            width: 200px;
        }
    }

    &__image-container {
        transform: translate(0, -30px);

        @media (max-width: 400px) {
            transform: translate(-10%, -30px);
        }

        @media (min-width: 700px) {
            transform: none;
        }
    }

    &__image {
        max-width: 330px;
        display: flex;
        align-items: center;

        @media (min-width: 600px) {
            max-width: 500px;
        }

        img {
            width: 100%;
            display: block;
        }
    }

    .hide-mobile {
        display: none;

        @media (min-width: 700px) {
            display: flex;
            justify-content: center;
        }
    }
}

</style>
